<div class="overlay-container">
    <superordenador-component></superordenador-component>
    <banner-component></banner-component>
</div>